import { render, staticRenderFns } from "./AppLayoutSideBar.vue?vue&type=template&id=0e21811e&"
import script from "./AppLayoutSideBar.vue?vue&type=script&lang=js&"
export * from "./AppLayoutSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports